module.exports = __webpack_public_path__ + "img/genero-tm.84c2fe0e.png";